import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory, Link } from "react-router-dom";
import * as actions from "./_redux/Actions";
import { NotificationContainer } from "react-notifications";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import moment from "moment";
import { Button, Accordion } from "react-bootstrap";
import sorter from "sort-nested-json";
import DataTable from "../../components/DataTable";
import * as columnFormatters from "../../components/column-formatters";

import TournamentSummeryDetails from "./TournamentSummeryDetails";
import { imageUrl } from "../../components/UIHelpers";

const RankSummary = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const columns = [
    {
      dataField: "noIndex",
      text: "Sr No",
      sort: false,
      show: true,
      format: {
        style: {
          width: "40px",
          minWidth: "40px",
        },
      },
    },
    {
      dataField: "usersJoinedTournamentData.playerName",
      text: "User Game Name",
      sort: true,
      show: true,
    },
    {
      dataField: "usersJoinedTournamentData.phone",
      text: "Mobile",
      sort: true,
      show: true,
    },
    {
      dataField: "rank",
      text: "Rank",
      sort: true,
      show: true,
    },
    {
      dataField: "kills",
      text: "Kills",
      sort: true,
      show: true,
    },
    {
      dataField: "rankAmount",
      text: "Rank Amount",
      sort: false,
      show: true,
    },
    {
      dataField: "totalAmount",
      text: "Winning Prize",
      sort: false,
      show: true,
    },
  ];

  const [rows, setRows] = useState([]);
  const [allColumns, setAllColumns] = useState(columns);
  const [sortDirection, setSortDirection] = useState([]);
  const [showSortArrow, setShowSortArrow] = useState([]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.tournamentsSlice }),
    shallowEqual
  );
  const { tournamentForEdit, rankSummaryUserListing } = currentState;

  useEffect(() => {
    dispatch(actions.getRankSummary(id));
    dispatch(actions.fetchSingle(id));
  }, [id]);

  const CurrencyIcoon = ({ item }) => {
    return (
      <span className="text-dark-50 font-weight-bold">
        {item.currency && item.currency.img ? (
          <img
            className="currency"
            // src={`${process.env.REACT_APP_UPLOADED_FILE_URL}/${item.currency &&
            //   item.currency.img.default}`}
              src={imageUrl(item.currency && item.currency.img.default)}
            alt="currency"
          />
        ) : (
          <span className="text-dark-50 font-weight-bold">₹</span>
        )}
      </span>
    );
  };

  const onClickSortCol = (key) => {
    let show_sort_arrow = showSortArrow;

    Object.keys(show_sort_arrow).forEach((obj_key) => {
      if (obj_key === key) show_sort_arrow[obj_key] = true;
      else show_sort_arrow[obj_key] = false;
    });
    setShowSortArrow(show_sort_arrow);

    // let sort_key = dataFromNestedKeys(key)

    let arrayCopy = [...rows];
    // arrayCopy.sort(compareBy(key, sortDirection[key]));

    if (sortDirection[key] === "asc")
      arrayCopy = sorter.sort(arrayCopy).asc(key);
    else arrayCopy = sorter.sort(arrayCopy).desc(key);

    setRows(arrayCopy);
    // this.setState({rows: arrayCopy});

    let sort_direction = sortDirection;
    if (sort_direction[key] === "asc") sort_direction[key] = "desc";
    else if (sort_direction[key] === "desc") sort_direction[key] = "asc";
    setSortDirection(sort_direction);
  };

  const createTableCol = () => {
    return allColumns.map((value, i) => {
      if (value?.format?.type !== "rowCollasible") {
        let style_icon = { color: "#fff" };
        let arrow_direction = "down";
        let className_cell_value = "";

        if (value?.sort && showSortArrow[value?.dataField])
          style_icon.display = "inline";
        else style_icon.display = "none";

        if (sortDirection[value?.dataField] === "asc") arrow_direction = "down";
        else if (sortDirection[value?.dataField] === "desc")
          arrow_direction = "up";

        if (value?.dataField === "image")
          className_cell_value = "data_table_cell_value_image";
        else className_cell_value = "data_table_cell_value";

        return (
          <th
            data-field={value?.dataField}
            data-sort="desc"
            key={i}
            className="datatable-cell datatable-cell-sort data_table_cell data_table_th"
            onClick={() => {
              value?.sort === true && onClickSortCol(value?.dataField);
            }}
            colSpan={1}
            rowSpan={1}
            style={value?.format?.thStyle}
          >
            <span
              className={`${className_cell_value} data_table_th_value`}
              style={value?.format?.style}
            >
              {value?.text}
              <i
                className={`flaticon2-arrow-${arrow_direction} icon-nm ml-1`}
                style={style_icon}
              ></i>
            </span>
          </th>
        );
      }
    });
  };
  const reloadLocation = () => {
    window.location.reload();
  };
  const onSubmitSummaryRank = () => {
    let payload = {
      tournamentId: id,
      contestPlayer: [],
    };
    rankSummaryUserListing.forEach((rank, i) => {
      payload.contestPlayer.push({
        _id: rank.usersJoinedTournamentData._id,
        rank: rank.rank,
        kills: rank.kills,
      });
    });
    dispatch(actions.updateWinning(payload)).then((sucess) =>
      sucess ? reloadLocation() : null
    );
  };
  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <TournamentSummeryDetails />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Card className="card_border">
            <NotificationContainer />
            <div className="card-header p-0">
              <div className="my-5 row mx-0 px-4 w-100 d-flex justify-content-between">
                <div
                  className=""
                  style={{ fontSize: "24px", fontWeight: "600" }}
                >
                  Tournament Users 22
                </div>
              </div>
            </div>

            <CardBody className="p-0 w-100">
              <DataTable
                rows={
                  rankSummaryUserListing.length > 0
                    ? rankSummaryUserListing
                    : []
                }
                columns={allColumns}
                isCollapsibleTableData={false}
                isPagination={false}
              />

              {tournamentForEdit.status !== "completed" && (
                <div className="btn-group btn-group-lg float-right m-5">
                  <button
                    type="submit"
                    className="btn btn-dark float-left"
                    disabled={rankSummaryUserListing.length === 0}
                    onClick={() => onSubmitSummaryRank()}
                  >
                    Submit
                  </button>
                </div>
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};

export default RankSummary;
